<template>
  <div class="relative z-[100 px-4 md:px-11 pt-20 md:pt-0 pb-6 bg-white flex flex-col">
    &nbsp;
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>